import { jsx as _jsx } from "react/jsx-runtime";
import { Overline } from '../server/typography/Overline/index';
const TONE_COLOR = {
    default: 'var(--muted-foreground)',
    onDark: '#f0e7e8',
    accent: 'var(--primary)',
    accentOnDark: 'var(--warning)',
};
export const Eyebrow = ({ children, tone = 'default', className, style }) => (_jsx(Overline, { case: "upper", style: { color: TONE_COLOR[tone], ...style }, ...(className ? { className } : {}), children: children }));
//# sourceMappingURL=Eyebrow.js.map